import type React from 'react'

/** Pen tool icon with a ± badge — shown when in node-edit pen sub-mode. */
export const PenPlusMinus: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    overflow="visible"
    className={className}
  >
    {/* Pen tool paths */}
    <path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z" />
    <path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18" />
    <path d="m2.3 2.3 7.286 7.286" />
    <circle cx="11" cy="11" r="2" />
    {/* ± badge lower-left — clear of pen body which ends at ~(5.35, 15.9) and (13, 18) */}
    <line x1="3" y1="18.5" x2="3" y2="25.5" strokeWidth="2.5" />
    <line x1="-0.5" y1="22" x2="6.5" y2="22" strokeWidth="2.5" />
  </svg>
)
